export enum LogEntityClass {
  CREATE_OPTION = "creation_option",
  DEVICE = "device",
  GATEWAY = "gateway",
  GROUP = "group",
  PLATFORM = "platform",
  PROFILE = "profile",
  ROLE = "role",
  SECTOR = "sector",
  USER = "user",
  CERTIFICATE = "certificate",
  TRUSTCHAIN = "trustchain",
  PKI = "pki_config",
  INTERFACE = "interface",
}
